import React from "react";
import SystemPage from "pages/Admin/Settings/SystemPage"
import Categories from "services/Admin/CategoriesService"

const CategoriesPage = (props) => {
        return <SystemPage
                Service={Categories}
                type={"Category"}
                placeholder={"catogory"}
                meta={"Categories"}
                header={"Categories"}
                hasSub={true}
        />

}

export default CategoriesPage;
